<template>
  <page-view :title="true" :descriptionInfo="description">
    <a-card :bordered="false">
      <a-steps class="steps" :current="currentTab">
        <a-step title="填写公共信息" />
        <a-step title="填写特有信息" />
        <a-step title="完成" />
      </a-steps>
      <div class="content">
        <step1
          ref="step1Info"
          v-show="currentTab === 0"
          :queryParam="queryParam"
          :baseInfo="baseInfo"
          @nextStep="nextStep"
        />
        <step2
          ref="step2"
          v-show="currentTab === 1"
          :baseInfo="baseInfo"
          :hinfo="houseInfo"
          :oss="oss"
          @nextStep="nextStep"
          @prevStep="prevStep"
        />
        <step3
          v-if="currentTab === 2"
          :queryParam="queryParam"
          :result="result"
          @prevStep="prevStep"
          @finish="finish"
        />
      </div>
    </a-card>
  </page-view>
</template>

<script>
import Step1 from "./stepForm/Step1";
import Step2 from "./stepForm/Step2";
import Step3 from "./stepForm/Step3";
import { PageView } from "@/layouts";
export default {
  name: "AddHouse",
  components: {
    PageView,
    Step1,
    Step2,
    Step3
  },
  data() {
    return {
      description:
        "将一个添加房源的表单任务分成多个步骤，对于添加合租房可提交效率。",
      currentTab: 0,
      // form
      form: null,
      userInfo: {},
      oss: {
        key: "",
        secret: "",
        service: "",
        floder: "",
        validTime: ""
      },
      baseInfo: {
        heatingTypeList: [],
        payWayList: [],
        rentTypeList: [],
        roomLayoutList: [],
        roomPartList: [],
        floorList: [],
        totalFloorList: [],
        keeperList: []
      },
      houseInfo: {
        houseList: []
      },
      queryParam: null,
      result: [] //上传房源返回结果
    };
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
    let query = this.$route.query;
    if (query.param) {
      this.queryParam = query.param;
    }
    this.getBaseInfo();
    this.getOssConfig();
    this.getKeeperList();
  },
  methods: {
    async getOssConfig() {
      this.$http.roomBksApi
        .findOssConfiguration({ type: "oss_image" })
        .then(res => {
          let info = res.resultObject;
          this.oss.key = info.accessKeyId;
          this.oss.secret = info.accessKeySecret;
          this.oss.service = info.accessService;
          this.oss.floder = info.floderSrc;
          this.oss.validTime = info.validTime;
        });
    },
    async getBaseInfo() {
      this.$http.roomBksApi.findHouseKindData().then(res => {
        Object.assign(this.baseInfo, res.resultObject);
        for (let i = 1; i < 100; i++) {
          this.baseInfo.floorList.push(i);
          this.baseInfo.totalFloorList.push(i);
        }
      });
    },
    async getKeeperList() {
      let param = {};
      param.merchantNo = this.userInfo.merchantNo;
      this.$http.roomBksApi.findKeeperHelpDto(param).then(res => {
        if (res.result == 0) {
          this.baseInfo.keeperList = res.resultObject;
        }
      });
    },
    nextStep(type, data) {
      if (type == 1) {
        Object.assign(this.houseInfo, data);
        this.houseInfo.merchantNo = this.userInfo.merchantNo;
        this.$refs.step2.setHouseInfo(this.houseInfo);
      } else if (type == 2) {
        this.result = data;
      }
      if (this.currentTab < 2) {
        this.currentTab += 1;
      }
    },
    prevStep() {
      if (this.currentTab > 0) {
        this.currentTab -= 1;
      }
    },
    finish() {
      this.currentTab = 0;
    }
  }
};
</script>

<style></style>
